import React, { useEffect } from "react";
import { connect } from "react-redux";
import PageHeader from "../../../shared/components/PageHeader";
import { Container, Row } from "reactstrap";
import DisbursementTable from "./components/DisbursementTable";
import { getdisbursements } from "../actions/disbursement.actions";

const DisbursementView = ({ dispatch, allDisbursments }) => {

  const loadDisbursement = (requestParams) => {
    dispatch(getdisbursements(requestParams));
  };

  useEffect(() => {
    dispatch(getdisbursements({ pageNum: 1, pageSize: 10, searchKey: "" }));
  }, [dispatch]);

  return (
    <Container>
      <PageHeader
        header="Disbursements"
        subheader="All disbursements generated are listed here"
      />
      <Row>
        <DisbursementTable
          dataState={allDisbursments}
          fetchData={loadDisbursement}
        />
      </Row>
    </Container>
  );
};

export default connect((state) => ({
  allDisbursments: state.getDisbursement
}))(DisbursementView);
